<template>
  <BaseCard
    :result="{
      orgName: searchResult.secondary_organization.name,
      orgLink: searchResult.link,
      tagName: $t(`search.liveFeed.tagName`),
      tagLink: `${searchResult.link}/live-feed`,
      id: searchResult.id,
      type: searchResult.type,
      result_position: resultPosition,
      display_text: searchResult.status,
      category: 'search_result',
    }"
    class="live-feed-card result-card"
    @result-clicked="handleResultClick"
  >
    <template #preview>
      <div
        v-if="searchResult.live_feed_images[0]?.image_url"
        class="preview-image"
      >
        <img
          :src="searchResult.live_feed_images[0].image_url"
          :alt="searchResult.live_feed_images[0]?.caption"
        />
      </div>
      <div
        v-else
        class="preview-fallback"
      >
        <Icon
          name="lucide:newspaper"
          size="24"
        />
      </div>
    </template>
    <template #result-content>
      <a
        :href="url"
        class="title"
        @click.stop="handleResultClick"
        >{{ statusText }}</a
      >
      <PublishedUpdatedDate :search-result="searchResult" />
    </template>
  </BaseCard>
</template>

<script setup>
import BaseCard from './BaseCard.vue';
import { computed } from 'vue';
import { stripHtml } from '../../../helpers/strings';
import PublishedUpdatedDate from './PublishedUpdatedDate.vue';

const emit = defineEmits(['result-clicked']);

const props = defineProps({
  searchResult: {
    type: Object,
    default: () => ({}),
  },
  resultPosition: {
    type: Number,
    required: true,
  },
});

const url = computed(() => {
  return `${props.searchResult.link}/live-feed#${props.searchResult.id}`;
});

async function handleResultClick() {
  await navigateTo(url.value, { external: true });
  emit('result-clicked', {
    position: props.resultPosition,
    url: url.value,
  });
}

const statusText = computed(() => {
  return stripHtml(props.searchResult.status);
});
</script>

<style scoped>
.live-feed-card {
  --background-color: #f3fafc;
  --text-color: #0592cc;
}

.live-feed-card .title {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.4;
}
</style>
